enum UIEnvironment {
  Local = "local",
  Production = "production",
}

export const currentEnvironment = process.env.REACT_APP_UI_ENVIRONMENT! as UIEnvironment

export const inLocal = currentEnvironment === UIEnvironment.Local
export const inProduction = currentEnvironment === UIEnvironment.Production
